export default {
	authorized: state => {
		return state.authorized;
	},
	modal: state => {
		return state.modal;
	},
	sessionId: state => {
		return state.sessionId;
	},
	objAuthorize: state => {
		if ( state.objAuthorize == '') {
			return [];
		}
		return JSON.parse(state.objAuthorize);
	},
	jwtAuth: state => {
		return state.jwtAuth;
	},
	globalSnackColor: state => {
		return state.globalSnackColor;
	},
	globalSnackDisplay: state => {
		return state.globalSnackDisplay;
	},
	globalSnackMessage: state => {
		return state.globalSnackMessage;
	},
	globalModalTitle: state => {
		return state.globalModalTitle;
	},
	globalModalComponent: state => {
		return state.globalModalComponent;
	},
	globalModalParams: state => {
		return state.globalModalParams;
	},
	globalModalState: state => {
		return state.globalModalState;
	},
	spineToken: state => {
		return state.spineToken;
	},
	spinePriceList: state => {
		return state.spinePriceList;
	},
	sideProps: state => {
		return state.sideProps;
	},
	isLoading: state => {
		return state.isLoading;
	},
  quotePagination: state => {
    return state.quotePagination;
  },
  setManufacturer: state => {
    return state.setManufacturer;
  },
}
